import { render, staticRenderFns } from "./AdminSettingsSharingForm.vue?vue&type=template&id=6717730d&scoped=true"
import script from "./AdminSettingsSharingForm.vue?vue&type=script&lang=ts"
export * from "./AdminSettingsSharingForm.vue?vue&type=script&lang=ts"
import style0 from "./AdminSettingsSharingForm.vue?vue&type=style&index=0&id=6717730d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6717730d",
  null
  
)

export default component.exports